// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanCoverageConfigDto } from './IPlanCoverageConfigDto';
import {
    IPlanCoverageConfigDtoFromJSON,
    IPlanCoverageConfigDtoFromJSONTyped,
    IPlanCoverageConfigDtoToJSON,
    IPlanCoverageConfigDtoToJSONTyped,
} from './IPlanCoverageConfigDto';
import type { IPlanPrimaryConfigDto } from './IPlanPrimaryConfigDto';
import {
    IPlanPrimaryConfigDtoFromJSON,
    IPlanPrimaryConfigDtoFromJSONTyped,
    IPlanPrimaryConfigDtoToJSON,
    IPlanPrimaryConfigDtoToJSONTyped,
} from './IPlanPrimaryConfigDto';
import type { IPlanPropertyChangeDto } from './IPlanPropertyChangeDto';
import {
    IPlanPropertyChangeDtoFromJSON,
    IPlanPropertyChangeDtoFromJSONTyped,
    IPlanPropertyChangeDtoToJSON,
    IPlanPropertyChangeDtoToJSONTyped,
} from './IPlanPropertyChangeDto';
import type { IAccountTypePropertyDto } from './IAccountTypePropertyDto';
import {
    IAccountTypePropertyDtoFromJSON,
    IAccountTypePropertyDtoFromJSONTyped,
    IAccountTypePropertyDtoToJSON,
    IAccountTypePropertyDtoToJSONTyped,
} from './IAccountTypePropertyDto';
import type { INamePropertyDto } from './INamePropertyDto';
import {
    INamePropertyDtoFromJSON,
    INamePropertyDtoFromJSONTyped,
    INamePropertyDtoToJSON,
    INamePropertyDtoToJSONTyped,
} from './INamePropertyDto';
import type { IPlanCategorySpendLimitDto } from './IPlanCategorySpendLimitDto';
import {
    IPlanCategorySpendLimitDtoFromJSON,
    IPlanCategorySpendLimitDtoFromJSONTyped,
    IPlanCategorySpendLimitDtoToJSON,
    IPlanCategorySpendLimitDtoToJSONTyped,
} from './IPlanCategorySpendLimitDto';
import type { IPlanAccountFundingConfigDto } from './IPlanAccountFundingConfigDto';
import {
    IPlanAccountFundingConfigDtoFromJSON,
    IPlanAccountFundingConfigDtoFromJSONTyped,
    IPlanAccountFundingConfigDtoToJSON,
    IPlanAccountFundingConfigDtoToJSONTyped,
} from './IPlanAccountFundingConfigDto';
import type { IPlanYearDto } from './IPlanYearDto';
import {
    IPlanYearDtoFromJSON,
    IPlanYearDtoFromJSONTyped,
    IPlanYearDtoToJSON,
    IPlanYearDtoToJSONTyped,
} from './IPlanYearDto';
import type { IPlanServiceConfigDto } from './IPlanServiceConfigDto';
import {
    IPlanServiceConfigDtoFromJSON,
    IPlanServiceConfigDtoFromJSONTyped,
    IPlanServiceConfigDtoToJSON,
    IPlanServiceConfigDtoToJSONTyped,
} from './IPlanServiceConfigDto';
import type { IPlanLiteDto } from './IPlanLiteDto';
import {
    IPlanLiteDtoFromJSON,
    IPlanLiteDtoFromJSONTyped,
    IPlanLiteDtoToJSON,
    IPlanLiteDtoToJSONTyped,
} from './IPlanLiteDto';
import type { IAuditActor } from './IAuditActor';
import {
    IAuditActorFromJSON,
    IAuditActorFromJSONTyped,
    IAuditActorToJSON,
    IAuditActorToJSONTyped,
} from './IAuditActor';

/**
 * 
 * @export
 * @interface IPlanDto
 */
export interface IPlanDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    parent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    plan_year_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    prior_plan_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanDto
     */
    is_first_plan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanDto
     */
    is_plan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanDto
     */
    is_forfeited?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanDto
     */
    is_replenished_plan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPlanDto
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanDto
     */
    plan_code: string;
    /**
     * 
     * @type {INamePropertyDto}
     * @memberof IPlanDto
     */
    name?: INamePropertyDto;
    /**
     * 
     * @type {IAccountTypePropertyDto}
     * @memberof IPlanDto
     */
    account_type?: IAccountTypePropertyDto;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    plan_omnibus_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    notional_payroll_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    notional_funding_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    inter_prefund_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    final_prefund_account_id?: number;
    /**
     * 
     * @type {IPlanPrimaryConfigDto}
     * @memberof IPlanDto
     */
    plan_primary_config?: IPlanPrimaryConfigDto;
    /**
     * 
     * @type {IPlanCoverageConfigDto}
     * @memberof IPlanDto
     */
    plan_coverage_config?: IPlanCoverageConfigDto;
    /**
     * 
     * @type {IPlanAccountFundingConfigDto}
     * @memberof IPlanDto
     */
    plan_account_funding_config?: IPlanAccountFundingConfigDto;
    /**
     * 
     * @type {IPlanYearDto}
     * @memberof IPlanDto
     */
    plan_year?: IPlanYearDto;
    /**
     * 
     * @type {IPlanLiteDto}
     * @memberof IPlanDto
     */
    prior_plan?: IPlanLiteDto;
    /**
     * 
     * @type {string}
     * @memberof IPlanDto
     */
    plan_status?: IPlanDtoPlanStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanDto
     */
    organization_path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanDto
     */
    deletable?: boolean;
    /**
     * 
     * @type {IAuditActor}
     * @memberof IPlanDto
     */
    audit_actor?: IAuditActor;
    /**
     * 
     * @type {string}
     * @memberof IPlanDto
     */
    update_source?: IPlanDtoUpdateSourceEnum;
    /**
     * 
     * @type {{ [key: string]: Array<IPlanServiceConfigDto>; }}
     * @memberof IPlanDto
     */
    service_configs?: { [key: string]: Array<IPlanServiceConfigDto>; };
    /**
     * 
     * @type {Set<number>}
     * @memberof IPlanDto
     */
    plan_config_service_ids?: Set<number>;
    /**
     * 
     * @type {Date}
     * @memberof IPlanDto
     */
    forfeiture_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPlanDto
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPlanDto
     */
    rollover_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanDto
     */
    is_eoy_reconciled?: boolean;
    /**
     * 
     * @type {Array<IPlanCategorySpendLimitDto>}
     * @memberof IPlanDto
     */
    category_spend_limits?: Array<IPlanCategorySpendLimitDto>;
    /**
     * 
     * @type {Date}
     * @memberof IPlanDto
     */
    submit_claims_date_end?: Date;
    /**
     * 
     * @type {Array<IPlanPropertyChangeDto>}
     * @memberof IPlanDto
     */
    modified_overridable_properties?: Array<IPlanPropertyChangeDto>;
    /**
     * 
     * @type {number}
     * @memberof IPlanDto
     */
    direct_child_plan_count?: number;
}

/**
* @export
* @enum {string}
*/
export enum IPlanDtoPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    READY_FOR_SETUP = 'READY_FOR_SETUP',
    DELETED = 'DELETED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    TERMINATED = 'TERMINATED',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
* @export
* @enum {string}
*/
export enum IPlanDtoUpdateSourceEnum {
    FILE = 'FILE',
    API = 'API',
    ADMIN_PORTAL = 'ADMIN_PORTAL',
    USER_PORTAL = 'USER_PORTAL'
}


/**
 * Check if a given object implements the IPlanDto interface.
 */
export function instanceOfIPlanDto(value: object): value is IPlanDto {
    if (!('plan_code' in value) || value['plan_code'] === undefined) return false;
    return true;
}

export function IPlanDtoFromJSON(json: any): IPlanDto {
    return IPlanDtoFromJSONTyped(json, false);
}

export function IPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'plan_year_id': json['plan_year_id'] == null ? undefined : json['plan_year_id'],
        'prior_plan_id': json['prior_plan_id'] == null ? undefined : json['prior_plan_id'],
        'is_first_plan': json['is_first_plan'] == null ? undefined : json['is_first_plan'],
        'is_plan': json['is_plan'] == null ? undefined : json['is_plan'],
        'is_forfeited': json['is_forfeited'] == null ? undefined : json['is_forfeited'],
        'is_replenished_plan': json['is_replenished_plan'] == null ? undefined : json['is_replenished_plan'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'plan_code': json['plan_code'],
        'name': json['name'] == null ? undefined : INamePropertyDtoFromJSON(json['name']),
        'account_type': json['account_type'] == null ? undefined : IAccountTypePropertyDtoFromJSON(json['account_type']),
        'plan_omnibus_account_id': json['plan_omnibus_account_id'] == null ? undefined : json['plan_omnibus_account_id'],
        'notional_payroll_account_id': json['notional_payroll_account_id'] == null ? undefined : json['notional_payroll_account_id'],
        'notional_funding_account_id': json['notional_funding_account_id'] == null ? undefined : json['notional_funding_account_id'],
        'inter_prefund_account_id': json['inter_prefund_account_id'] == null ? undefined : json['inter_prefund_account_id'],
        'final_prefund_account_id': json['final_prefund_account_id'] == null ? undefined : json['final_prefund_account_id'],
        'plan_primary_config': json['plan_primary_config'] == null ? undefined : IPlanPrimaryConfigDtoFromJSON(json['plan_primary_config']),
        'plan_coverage_config': json['plan_coverage_config'] == null ? undefined : IPlanCoverageConfigDtoFromJSON(json['plan_coverage_config']),
        'plan_account_funding_config': json['plan_account_funding_config'] == null ? undefined : IPlanAccountFundingConfigDtoFromJSON(json['plan_account_funding_config']),
        'plan_year': json['plan_year'] == null ? undefined : IPlanYearDtoFromJSON(json['plan_year']),
        'prior_plan': json['prior_plan'] == null ? undefined : IPlanLiteDtoFromJSON(json['prior_plan']),
        'plan_status': json['plan_status'] == null ? undefined : json['plan_status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'deletable': json['deletable'] == null ? undefined : json['deletable'],
        'audit_actor': json['audit_actor'] == null ? undefined : IAuditActorFromJSON(json['audit_actor']),
        'update_source': json['update_source'] == null ? undefined : json['update_source'],
        'service_configs': json['service_configs'] == null ? undefined : json['service_configs'],
        'plan_config_service_ids': json['plan_config_service_ids'] == null ? undefined : new Set(json['plan_config_service_ids']),
        'forfeiture_date': json['forfeiture_date'] == null ? undefined : (new Date(json['forfeiture_date'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'rollover_date': json['rollover_date'] == null ? undefined : (new Date(json['rollover_date'])),
        'is_eoy_reconciled': json['is_eoy_reconciled'] == null ? undefined : json['is_eoy_reconciled'],
        'category_spend_limits': json['category_spend_limits'] == null ? undefined : ((json['category_spend_limits'] as Array<any>).map(IPlanCategorySpendLimitDtoFromJSON)),
        'submit_claims_date_end': json['submit_claims_date_end'] == null ? undefined : (new Date(json['submit_claims_date_end'])),
        'modified_overridable_properties': json['modified_overridable_properties'] == null ? undefined : ((json['modified_overridable_properties'] as Array<any>).map(IPlanPropertyChangeDtoFromJSON)),
        'direct_child_plan_count': json['direct_child_plan_count'] == null ? undefined : json['direct_child_plan_count'],
    };
}

export function IPlanDtoToJSON(json: any): IPlanDto {
    return IPlanDtoToJSONTyped(json, false);
}

export function IPlanDtoToJSONTyped(value?: IPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parent_id': value['parent_id'],
        'plan_year_id': value['plan_year_id'],
        'prior_plan_id': value['prior_plan_id'],
        'is_first_plan': value['is_first_plan'],
        'is_plan': value['is_plan'],
        'is_forfeited': value['is_forfeited'],
        'is_replenished_plan': value['is_replenished_plan'],
        'summary': value['summary'],
        'plan_code': value['plan_code'],
        'name': INamePropertyDtoToJSON(value['name']),
        'account_type': IAccountTypePropertyDtoToJSON(value['account_type']),
        'plan_omnibus_account_id': value['plan_omnibus_account_id'],
        'notional_payroll_account_id': value['notional_payroll_account_id'],
        'notional_funding_account_id': value['notional_funding_account_id'],
        'inter_prefund_account_id': value['inter_prefund_account_id'],
        'final_prefund_account_id': value['final_prefund_account_id'],
        'plan_primary_config': IPlanPrimaryConfigDtoToJSON(value['plan_primary_config']),
        'plan_coverage_config': IPlanCoverageConfigDtoToJSON(value['plan_coverage_config']),
        'plan_account_funding_config': IPlanAccountFundingConfigDtoToJSON(value['plan_account_funding_config']),
        'plan_year': IPlanYearDtoToJSON(value['plan_year']),
        'prior_plan': IPlanLiteDtoToJSON(value['prior_plan']),
        'plan_status': value['plan_status'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'deletable': value['deletable'],
        'audit_actor': IAuditActorToJSON(value['audit_actor']),
        'update_source': value['update_source'],
        'service_configs': value['service_configs'],
        'plan_config_service_ids': value['plan_config_service_ids'] == null ? undefined : Array.from(value['plan_config_service_ids'] as Set<any>),
        'forfeiture_date': value['forfeiture_date'] == null ? undefined : ((value['forfeiture_date']).toISOString().substring(0,10)),
        'notes': value['notes'],
        'rollover_date': value['rollover_date'] == null ? undefined : ((value['rollover_date']).toISOString().substring(0,10)),
        'is_eoy_reconciled': value['is_eoy_reconciled'],
        'category_spend_limits': value['category_spend_limits'] == null ? undefined : ((value['category_spend_limits'] as Array<any>).map(IPlanCategorySpendLimitDtoToJSON)),
        'submit_claims_date_end': value['submit_claims_date_end'] == null ? undefined : ((value['submit_claims_date_end']).toISOString().substring(0,10)),
        'modified_overridable_properties': value['modified_overridable_properties'] == null ? undefined : ((value['modified_overridable_properties'] as Array<any>).map(IPlanPropertyChangeDtoToJSON)),
        'direct_child_plan_count': value['direct_child_plan_count'],
    };
}

